<template>
  <div class="about-page">
    <page-cover :cover="cover"  v-if="cover" />
    <About />
    <TeamSection />
  </div>
</template>
<script>
import PageCover from "@/components/shared/PageCover.vue";
import About from "@/components/about/About.vue";
import TeamSection from "@/components/about/TeamSection.vue";
import { mapGetters } from "vuex";
export default {
  name: "about",
  computed: {
    ...mapGetters({
      cover: "pageCover/getAbout",
    }),
  },
  created() {
    this.$store.dispatch("about/getEmployees");
  },
  components: {
    PageCover,
    About,
    TeamSection,
  },
};
</script>